/** Pages preserve every source character; line/column limits bound the rendered text. */
export function paginateEvidenceText(text: string, columns: number, rows: number): string[] {
  const pages: string[] = [];
  let start = 0,
    column = 0,
    row = 0;
  for (let index = 0; index < text.length; ) {
    const point = text.codePointAt(index)!;
    const character = String.fromCodePoint(point);
    index += character.length;
    if (character === '\n') {
      row += 1;
      column = 0;
    } else {
      // Count wide glyphs conservatively and never split a surrogate pair.
      column +=
        /\p{Mark}/u.test(character) || character === '\u200d'
          ? 0
          : point > 0xffff || (point >= 0x2e80 && point <= 0xffef)
            ? 2
            : 1;
      if (column >= columns) {
        row += 1;
        column = 0;
      }
    }
    if (row >= rows) {
      pages.push(text.slice(start, index));
      start = index;
      row = 0;
      column = 0;
    }
  }
  if (start < text.length || !pages.length) pages.push(text.slice(start));
  return pages;
}
